<template>
    <div id="schoolAdd">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-button size="medium" type="primary" @click="onsave">保存</el-button>
        </div>
        <div class="body" :style="`height: ${windowHeight-180}px;`">
            <div style="width: 810px;padding-top:20px;margin: 0 auto;">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="学校Logo(长)" prop="logo">
                        <img :src="logo[logo.length - 1].fileUrl" class="logo-image"/>
                        <uploader ref="coverUploader" pathPrefix="moduleApp"
                                  :extList="['bmp', 'png', 'jpg', 'jpeg', 'gif']" showResult="image" multiple
                                  showMode="button" v-model="logo"></uploader>
                    </el-form-item>
                    <el-form-item label="学校Logo(圆)" prop="roundLogo">
                        <img :src="roundLogo[roundLogo.length - 1].fileUrl" class="logo-image"/>
                        <uploader ref="coverUploader" pathPrefix="moduleApp"
                                  :extList="['bmp', 'png', 'jpg', 'jpeg', 'gif']" showResult="image" multiple
                                  showMode="button" v-model="roundLogo"></uploader>
                    </el-form-item>
                    <el-form-item label="学校名称" prop="name">
                        <el-input v-model="formData.name" :maxlength="45" placeholder="请输入学校名称"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人" prop="managerName">
                        <el-input v-model="formData.managerName" :maxlength="20" placeholder="请输入联系人"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" prop="managerMobile">
                        <el-input v-model="formData.managerMobile" :maxlength="11" placeholder="请输入手机号码"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="managerEmail">
                        <el-input v-model="formData.managerEmail" :maxlength="30" placeholder="请输入邮箱"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="经销商">
                        <!-- <el-input v-model="formData.bussinessNumber" :maxlength="8" placeholder="请输入经销商编码"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input> -->
                              <el-select size="medium" v-model="formData.bussinessNumber" placeholder="请选择">
                                  <el-option v-for="{bussinessNumber, bussinessName} in allBussiness" :key="bussinessNumber" :label="bussinessName"
                                            :value="bussinessNumber"></el-option>
                              </el-select>
                    </el-form-item>
                    <el-form-item label="学校类型" prop="type">
                        <el-select size="medium" v-model="formData.type" placeholder="请选择">
                            <el-option v-for="[value, label] in schoolTypeConstants" :key="value" :label="label"
                                       :value="value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属区域" prop="managerEmail">
                        <location-selector v-model="locationArray" :hasDistAll="false"
                                           ref="locationSelector"></location-selector>
                    </el-form-item>
                    <el-form-item label="客户端类型" prop="clientType">
                        <el-radio-group v-model="formData.clientType">-->
                            <el-radio :label="1">企业微信</el-radio>
                            <el-radio :label="2">农行</el-radio>
                            <el-radio :label="12">企业微信及农行</el-radio>
                            <el-radio :label="3">建行生活</el-radio>
                            <el-radio :label="4">建行APP</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <!--                    <el-form-item label="消息类型" prop="msgType">-->
                    <!--                        <el-radio-group v-model="formData.msgType">-->
                    <!--                            <el-radio :label="1">微校+</el-radio>-->
                    <!--                            <el-radio :label="2">消息中心</el-radio>-->
                    <!--                        </el-radio-group>-->
                    <!--                    </el-form-item>-->
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import LocationSelector from '@/components/LocationSelector';
    import BackTool from '@/components/BackTool';
    import Uploader from '@/components/Uploader/WebUploader';
    import {mobileValidator, emailValidator} from '@/utils/validate';
    import {schoolTypeConstants} from '@/utils/constants';
    import {insertSchool, queryBussinessListAll} from '@/api/schoolManage';
    import mixin from "@/mixins/windowResize";

    export default {
        name: 'schoolAdd',
        components: {BackTool, Uploader, LocationSelector},
        data() {
            const validateLogo = (rule, value, callback) => {
                if (this.logo.length === 0) {
                    callback(new Error('请上传logo'));
                } else {
                    callback();
                }
            };
            return {
                schoolTypeConstants,
                formData: {
                    bussinessNumber: '',
                    managerEmail: '',
                    managerMobile: '',
                    managerName: '',
                    // msgType: 1,
                    name: '',
                    type: '',
                    clientType: 1
                },
                locationArray: ['320000', '320100', '320102'],
                rules: {
                    logo: [
                        {required: true, validator: validateLogo}
                    ],
                    roundLogo: [
                        {required: true, validator: validateLogo}
                    ],
                    name: [
                        {required: true, message: '请输入学校名称', trigger: 'blur'},
                    ],
                    managerName: [
                        {required: true, message: '请输入联系人', trigger: 'blur'},
                    ],
                    managerMobile: [
                        {required: true, trigger: 'blur', validator: mobileValidator},
                    ],
                    managerEmail: [
                        {required: true, trigger: 'blur', validator: emailValidator},
                    ],
                    // msgType: [
                    //     {required: true, message: '请选择消息类型', trigger: 'blur'},
                    // ],
                    type: [
                        {required: true, message: '请选择学校类型', trigger: 'blur'},
                    ],
                    clientType: [
                        {required: true, message: '请选择客户端类型', trigger: 'blur'},
                    ]

                },
                logo: [{
                    fileUrl: 'https://cdnfile-10043692.file.myqcloud.com/admin/images/wyms/default_logo.png'
                }],
                roundLogo: [{
                    fileUrl: 'https://cdnfile-10043692.file.myqcloud.com/admin/images/round_logo.png'
                }],
                moduleTypeList: [],
                allBussiness: []
            }
        },
        mixins: [mixin],
        created() {
          this.initAllBussiness()
        },
        methods: {
            initAllBussiness() {
              queryBussinessListAll().then(res => {
                this.allBussiness = res
              })
            },
            onsave() {
                this.$refs.form.validate(isValid => {
                    if (isValid) {
                        const args = JSON.parse(JSON.stringify(this.formData));
                        args.squareLogoUrl = this.logo[this.logo.length - 1].fileUrl;
                        args.roundLogoUrl = this.roundLogo[this.roundLogo.length - 1].fileUrl;
                        args.areaCode = this.locationArray[2] == '0' ? (this.locationArray[1] == '0' ? (this.locationArray[0] == '' ? '' : this.locationArray[0]) : this.locationArray[1]) : this.locationArray[2];
                        args.orgAreaCode = this.locationArray.join(',');
                        args.orgAreaName = this.$refs.locationSelector.getNameArray().join(' ');

                        insertSchool(args)
                            .then(() => {
                                this.$message.success(`新增成功`);
                                window.setTimeout(() => {
                                    this.$router.back();
                                }, 500);
                            })
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    #schoolAdd {
        padding: 12px;

        .upload-block-container {
            display: none;
        }

        .logo-image {
            height: 100px;
            margin-right: 10px;
            float: left;
        }

        .upload-btn {
            margin-top: 30px;
        }

        .top {
            border-bottom: 1px solid #e7eaec;
            padding-bottom: 10px;
        }

        .body {
            overflow: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolAdd.vue